import { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import { routesFlat } from "../../constants";
import { NewsView, NewsEdit } from "../News";
import { EventsView, EventsEdit } from "../Events";
import MakeAdmin from "../UserManagement";
import Redirect from "../Redirect";
import Landing from "../Landing";
import { CMSContext } from "../..";

export const routes = [
  {
    display: "/",
    path: `${routesFlat.landing}`,
    element: <Landing />,
  },
  {
    display: "News View",
    path: routesFlat.newsView,
    element: <NewsView />,
  },
  {
    display: "New Article",
    path: routesFlat.newsEdit,
    element: <NewsEdit />,
  },
  {
    display: "Edit Article",
    path: `${routesFlat.newsEdit}/:id`,
    element: <NewsEdit />,
  },
  {
    display: "View Events",
    path: `${routesFlat.eventsView}`,
    element: <EventsView />,
  },
  {
    display: "New Event",
    path: `${routesFlat.eventsEdit}`,
    element: <EventsEdit />,
  },
  {
    display: "Edit Event",
    path: `${routesFlat.eventsEdit}/:id`,
    element: <EventsEdit />,
  },
  {
    display: "Add New Admin",
    path: `${routesFlat.makeAdmin}`,
    element: <MakeAdmin />,
  },
  {
    display: "404",
    path: "*",
    element: <Redirect />,
    displayInNav: false,
  },
];

const RoutesMap = (routes) => {
  const { state } = useContext(CMSContext);
  return routes.map(({ path, element }) => {
    return (
      <Route path={path} key={path} element={state ? element : <Redirect />} />
    );
  });
};

export default function RoutesComp() {
  return <Routes>{RoutesMap(routes)}</Routes>;
}
